import { useRouter } from 'next/navigation';
import useSWRMutation from 'swr/mutation';
import { z } from 'zod';
import { validateResponse } from '@/utils/httpResponse';

const responseSchema = z.object({
  success: z.coerce.boolean(),
});

const postLogin = async () => {
  const response = await fetch('/api/expire', { method: 'POST' });

  await validateResponse(response);

  return response;
};

interface ReturnProps {
  error: any;
  trigger: () => void;
  isMutating: boolean;
}

const useLogout = (): ReturnProps => {
  const router = useRouter();
  const { push } = router;

  return useSWRMutation(`/api/expire`, () => async () => {
    const response = await postLogin();
    const data = await response.json();
    const { success } = responseSchema.parse(data);

    if (!success) throw new Error('Error while logging out');

    push('/login');
  });
};

export default useLogout;
